import DataTableView from "@components/views/datatable-view";
import LoadingButton from "@components/ui-components/loading-button";
import usePageChange from "@hooks/use-page-change";
import useTemplates from "./use-templates";
import UpsertTemplates from "./upsert";

export const Templates = () => {
    const {
        data: { templates = [], pagination = {} },
        loading,
        columns,
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getAllTemplates
    } = useTemplates();

    /* A custom hook that is used to handle the pagination. */
    const { handlePageChange, handlePerRowsChange } = usePageChange({
        setQueryParams
    });
    return (
        <>
            <DataTableView
                moduleName={"Templates"}
                breadcrumbItems={{
                    items: [
                        {
                            title : "Templates",
                            active: true
                        }
                    ]
                }}
                loading={loading}
                tableProps={{
                    data: templates,
                    columns,
                    handlePageChange,
                    handlePerRowsChange,
                    pagination
                }}
                actionItems={
                    <LoadingButton
                        color="primary"
                        icon="plus"
                        onClick={() => handleModalConfig()}
                        subject="templates"
                        text="Add Template"/>
                }/>
            <UpsertTemplates
                getAllTemplates={getAllTemplates}
                modalConfig={modalConfig}
                handleModal={handleModalConfig}/>
        </>
    );
};